import { INERTNESS_MAX_AWAIT_TIME, INERTNESS_MOVE_DISTANCE_MULTIPLIER, INERTNESS_MOVE_MAX_DISTANCE, IS_DEV_MODE_ENABLED, } from '../consts';
export class Controls {
    constructor(canvasEl, controlsArea, viewport) {
        Object.defineProperty(this, "controlsArea", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "viewport", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "canvasEl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onMoveCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onTouchMoveCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onMoveAnimatedCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onMoveUnpressedCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onInertnessMoveCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onDblclickCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onCenterImageCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onInitialPointerPosSetCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onScaleImageIncreaseAnimatedCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onScaleImageDecreaseAnimatedCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onScaleImageSetValueCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onSetZoomLevelAnimatedCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isInitialPointerPosSet", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "testEl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "setMoveCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (callback) => {
                this.onMoveCallback = callback;
            }
        });
        Object.defineProperty(this, "setTouchMoveCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (callback) => {
                this.onTouchMoveCallback = callback;
            }
        });
        Object.defineProperty(this, "setMoveAnimatedCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (callback) => {
                this.onMoveAnimatedCallback = callback;
            }
        });
        Object.defineProperty(this, "setMoveUnpressedCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (callback) => {
                this.onMoveUnpressedCallback = callback;
            }
        });
        Object.defineProperty(this, "setInertnessMoveCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (callback) => {
                this.onInertnessMoveCallback = callback;
            }
        });
        Object.defineProperty(this, "setDblclickCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (callback) => {
                this.onDblclickCallback = callback;
            }
        });
        Object.defineProperty(this, "setCenterImageCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (callback) => {
                this.onCenterImageCallback = callback;
            }
        });
        Object.defineProperty(this, "setOnInitialPointerPosSetCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (callback) => {
                this.onInitialPointerPosSetCallback = callback;
            }
        });
        Object.defineProperty(this, "setScaleImageIncreaseAnimatedCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (callback) => {
                this.onScaleImageIncreaseAnimatedCallback = callback;
            }
        });
        Object.defineProperty(this, "setScaleImageDecreaseAnimatedCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (callback) => {
                this.onScaleImageDecreaseAnimatedCallback = callback;
            }
        });
        Object.defineProperty(this, "setScaleImageSetValueCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (callback) => {
                this.onScaleImageSetValueCallback = callback;
            }
        });
        Object.defineProperty(this, "setZoomLevelAnimatedCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (callback) => {
                this.onSetZoomLevelAnimatedCallback = callback;
            }
        });
        Object.defineProperty(this, "onZoomIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (callback) => {
                callback();
            }
        });
        Object.defineProperty(this, "createButtons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const buttonMoveLeft = document.createElement('button');
                buttonMoveLeft.innerHTML = 'left';
                const buttonMoveRight = document.createElement('button');
                buttonMoveRight.innerHTML = 'right';
                const buttonMoveUp = document.createElement('button');
                buttonMoveUp.innerHTML = 'up';
                const buttonMoveDown = document.createElement('button');
                buttonMoveDown.innerHTML = 'down';
                const buttonCenterImage = document.createElement('button');
                buttonCenterImage.innerHTML = 'center image';
                const buttonScaleImagePlus = document.createElement('button');
                buttonScaleImagePlus.innerHTML = 'zoom +';
                const buttonScaleImageMinus = document.createElement('button');
                buttonScaleImageMinus.innerHTML = 'zoom -';
                const buttonScaleImageInitial = document.createElement('button');
                buttonScaleImageInitial.innerHTML = 'scale initial';
                const buttonScaleImageMax = document.createElement('button');
                buttonScaleImageMax.innerHTML = 'scale max';
                const buttonScaleImageMin = document.createElement('button');
                buttonScaleImageMin.innerHTML = 'scale min';
                const buttonScaleImageHalf = document.createElement('button');
                buttonScaleImageHalf.innerHTML = 'scale half';
            }
        });
        Object.defineProperty(this, "setInitialPointerPos", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (x, y) => {
                if (this.isInitialPointerPosSet)
                    return;
                this.isInitialPointerPosSet = true;
                this.onInitialPointerPosSetCallback?.(x, y);
            }
        });
        Object.defineProperty(this, "bindMoveEventsHandlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (el) => {
                let isMousePressed = false;
                let isInertness = false;
                let lastMoveX = 0;
                let lastMoveY = 0;
                let lastMoveTimestamp = 0;
                el.onmousedown = () => {
                    isMousePressed = true;
                    isInertness = true;
                };
                el.onmouseup = (e) => {
                    isMousePressed = false;
                    if (isInertness && lastMoveTimestamp && e.timeStamp - lastMoveTimestamp < INERTNESS_MAX_AWAIT_TIME) {
                        isInertness = false;
                        let x = lastMoveX * INERTNESS_MOVE_DISTANCE_MULTIPLIER;
                        const y = lastMoveY * INERTNESS_MOVE_DISTANCE_MULTIPLIER;
                        if (x > INERTNESS_MOVE_MAX_DISTANCE)
                            x = INERTNESS_MOVE_MAX_DISTANCE;
                        if (y > INERTNESS_MOVE_MAX_DISTANCE)
                            x = INERTNESS_MOVE_MAX_DISTANCE;
                        if (x < -INERTNESS_MOVE_MAX_DISTANCE)
                            x = -INERTNESS_MOVE_MAX_DISTANCE;
                        if (y < -INERTNESS_MOVE_MAX_DISTANCE)
                            x = -INERTNESS_MOVE_MAX_DISTANCE;
                        if (this.onInertnessMoveCallback !== null) {
                            this.onInertnessMoveCallback(x, y);
                        }
                    }
                    else {
                        lastMoveX = 0;
                        lastMoveY = 0;
                    }
                };
                el.onmouseleave = () => {
                    isMousePressed = false;
                    isInertness = false;
                };
                el.onmousemove = (e) => {
                    if (isMousePressed) {
                        const x = e.movementX;
                        const y = e.movementY;
                        lastMoveX = x;
                        lastMoveY = y;
                        lastMoveTimestamp = e.timeStamp;
                        if (this.onMoveCallback !== null) {
                            this.onMoveCallback(x, y);
                        }
                    }
                    else {
                        const canvasElBounding = this.canvasEl.getBoundingClientRect();
                        const offsetX = canvasElBounding.x + window.scrollX;
                        const offsetY = canvasElBounding.y + window.scrollY;
                        const x = e.pageX - offsetX;
                        const y = e.pageY - offsetY;
                        if (this.onMoveUnpressedCallback !== null) {
                            this.onMoveUnpressedCallback(x, y);
                        }
                    }
                };
                el.ondblclick = (e) => {
                    e.preventDefault();
                    this.setInitialPointerPos(e.clientX, e.clientY);
                    this.onDblclickCallback?.();
                };
                const TOUCH_MULTIPLIER = 1;
                let touchStartX;
                let touchStartY;
                let touchesCount;
                let singleTouchId;
                const multiTouches = {
                    0: [0, 0],
                    1: [0, 0],
                };
                let diff;
                let handleMulti = false;
                const handleTouchStart = (e) => {
                    touchStartX = e.touches[0].clientX;
                    touchStartY = e.touches[0].clientY;
                    touchesCount = e.touches.length;
                    if (touchesCount === 1) {
                        singleTouchId = e.touches[0].identifier;
                        isInertness = true;
                    }
                };
                const handleTouchMove = (e) => {
                    e.preventDefault();
                    this.setInitialPointerPos(e.touches[0].clientX, e.touches[0].clientY);
                    touchesCount = e.touches.length;
                    if (touchesCount === 1) {
                        if (handleMulti) {
                            handleMulti = false;
                        }
                        else {
                            if (e.touches[0].identifier === singleTouchId) {
                                if (this.onMoveCallback !== null) {
                                    const distanceX = (e.touches[0].clientX - touchStartX) * TOUCH_MULTIPLIER;
                                    const distanceY = (e.touches[0].clientY - touchStartY) * TOUCH_MULTIPLIER;
                                    lastMoveX = distanceX;
                                    lastMoveY = distanceY;
                                    lastMoveTimestamp = e.timeStamp;
                                    this.onMoveCallback(distanceX, distanceY);
                                }
                            }
                        }
                        touchStartX = e.touches[0].clientX;
                        touchStartY = e.touches[0].clientY;
                    }
                    if (touchesCount === 2) {
                        isInertness = false;
                        handleMulti = true;
                        const keys = Object.keys(e.touches);
                        keys.forEach((key) => {
                            const touch = e.touches?.[key];
                            const id = +key;
                            if (id === 0 || id === 1)
                                multiTouches[id] = [touch.pageX, touch.pageY];
                        });
                        if (multiTouches[0][0] && multiTouches[1][0]) {
                            if (e.touches[0] && e.touches[1]) {
                                const x = (e.touches[0].clientX + e.touches[1].clientX) / 2;
                                const y = (e.touches[0].clientY + e.touches[1].clientY) / 2;
                                if (this.onMoveUnpressedCallback !== null) {
                                    this.onMoveUnpressedCallback(x, y);
                                }
                            }
                            const newDiff = Math.abs(multiTouches[0][0] - multiTouches[1][0]) + Math.abs(multiTouches[0][1] - multiTouches[1][1]);
                            const oldDiff = diff ? diff : newDiff;
                            const diffDiffSum = newDiff - oldDiff;
                            diff = newDiff;
                            if (IS_DEV_MODE_ENABLED && this.testEl) {
                                this.testEl.innerHTML = `<p>touch0: ${multiTouches[0][0]}, ${multiTouches[0][1]}.</p><p>touch1: ${multiTouches[1][0]}, ${multiTouches[1][1]}.</p>`;
                            }
                            const zoomAmount = Math.abs(diffDiffSum) / 2;
                            const stepVal = zoomAmount / 100 + 1;
                            const percentageRaw = this?.viewport?.zoomPercentageTarget;
                            if (percentageRaw) {
                                if (diffDiffSum > 0)
                                    this.onSetZoomLevelAnimatedCallback?.(percentageRaw * stepVal, true);
                                if (diffDiffSum < 0)
                                    this.onSetZoomLevelAnimatedCallback?.(percentageRaw / stepVal, true);
                            }
                        }
                    }
                };
                const handleTouchEnd = (e) => {
                    if (isInertness && lastMoveTimestamp && e.timeStamp - lastMoveTimestamp < INERTNESS_MAX_AWAIT_TIME) {
                        isInertness = false;
                        let x = lastMoveX * INERTNESS_MOVE_DISTANCE_MULTIPLIER;
                        const y = lastMoveY * INERTNESS_MOVE_DISTANCE_MULTIPLIER;
                        if (x > INERTNESS_MOVE_MAX_DISTANCE)
                            x = INERTNESS_MOVE_MAX_DISTANCE;
                        if (y > INERTNESS_MOVE_MAX_DISTANCE)
                            x = INERTNESS_MOVE_MAX_DISTANCE;
                        if (x < -INERTNESS_MOVE_MAX_DISTANCE)
                            x = -INERTNESS_MOVE_MAX_DISTANCE;
                        if (y < -INERTNESS_MOVE_MAX_DISTANCE)
                            x = -INERTNESS_MOVE_MAX_DISTANCE;
                        if (this.onInertnessMoveCallback !== null) {
                            this.onInertnessMoveCallback(x, y);
                        }
                    }
                    else {
                        lastMoveX = 0;
                        lastMoveY = 0;
                    }
                    touchesCount = 0;
                    multiTouches[0] = [0, 0];
                    multiTouches[1] = [0, 0];
                    diff = 0;
                };
                el.ontouchstart = handleTouchStart;
                el.ontouchmove = handleTouchMove;
                el.ontouchend = handleTouchEnd;
                const handleWheel = (e) => {
                    this.setInitialPointerPos(e.clientX, e.clientY);
                    const absDelta = Math.abs(e.deltaY);
                    let zoomAmount;
                    const isPitchZoom = Math.ceil(absDelta) !== absDelta;
                    if (!isPitchZoom) {
                        zoomAmount = absDelta / 11;
                    }
                    else {
                        zoomAmount = absDelta / 1.5;
                    }
                    const stepVal = zoomAmount / 100 + 1;
                    const percentageRaw = this?.viewport?.zoomPercentageTarget;
                    if (percentageRaw) {
                        if (e.deltaY > 0)
                            this.onSetZoomLevelAnimatedCallback?.(percentageRaw / stepVal, true);
                        if (e.deltaY < 0)
                            this.onSetZoomLevelAnimatedCallback?.(percentageRaw * stepVal, true);
                    }
                };
                el.onwheel = handleWheel;
            }
        });
        this.canvasEl = canvasEl;
        this.controlsArea = controlsArea;
        this.viewport = viewport || null;
        this.onMoveCallback = null;
        this.onTouchMoveCallback = null;
        this.onMoveAnimatedCallback = null;
        this.onMoveUnpressedCallback = null;
        this.onInertnessMoveCallback = null;
        this.onDblclickCallback = null;
        this.onCenterImageCallback = null;
        this.onInitialPointerPosSetCallback = null;
        this.onScaleImageIncreaseAnimatedCallback = null;
        this.onScaleImageDecreaseAnimatedCallback = null;
        this.onScaleImageSetValueCallback = null;
        this.onSetZoomLevelAnimatedCallback = null;
        if (IS_DEV_MODE_ENABLED) {
            this.testEl = document.createElement('div');
            this.testEl.innerHTML = 'test element';
            this.controlsArea.appendChild(this.testEl);
        }
        this.isInitialPointerPosSet = false;
    }
}
